// strings/title.ts (title screen, 2026-10-05) — the landing every launch opens on: what this is, Play now, and the short version.
// pageTitle is the static <title> and og:title, and metaDescription the <meta name="description"> and og:description, in
// apps/client/index.html (boot/appName.test.ts keeps them equal).
import type { StringBank } from '../schema/strings';

export default {
  lead: 'Your friends really live here.',
  blurb: 'A cozy town you share with friends, each on their own phone: fish, dig up fossils, decorate your house, fill a museum together and swap letters.',
  play: 'Play now',
  more: 'What is this?',
  music: 'Music',
  musicOn: 'Music is on',
  musicOff: 'Music is off',
  aboutTitle: 'The short version',
  friendsTitle: 'Your friends, actually here',
  friendsBody: 'Everyone plays on their own phone, as a neighbour with a house of their own. The town stays open, nobody has to host, and dropping in interrupts no one.',
  houseTitle: 'A house, and a loan to match',
  houseBody: 'You move in with a tent and a modest debt. Pay it off however you can, then decorate the place exactly as well or as badly as you like.',
  findsTitle: 'Fish, fruit and fossils',
  findsBody: 'Cast a line, shake a tree, dig where the ground looks suspicious. Your finds are yours each day, and the museum fills up with everyone’s donations.',
  postTitle: 'Letters, news and gossip',
  postBody: 'Send letters and gifts, check the news board, and chat with the villagers, who will happily tell you what your friends have been up to.',
  inviteOnly: 'Towns are invite-only. Found one of your own, or open the link a friend sent you.',
  pageTitle: '{app}: your friends really live here',
  metaDescription: 'A cozy town you share with friends, each on their own phone. Fish, dig up fossils, decorate your house, fill a museum together and swap letters.',
} as const satisfies StringBank;
